'use client';

import { HelpCircle, Book, MessageCircle, ArrowLeft } from 'lucide-react';
import Link from 'next/link';

export default function HelpPage() {
 return (
 <div className="min-h-screen bg-black text-neutral-200 font-sans selection:bg-blue-500/30">
 <div className="p-8 pt-16">
 {/* Back Link */}
 <Link
 href="/"
 className="inline-flex items-center gap-2 text-zinc-400 hover:text-emerald-400 transition-colors mb-8"
 >
 <ArrowLeft size={16} />
 Back to Home
 </Link>

 {/* Header */}
 <div className="mb-8">
 <div className="flex items-center gap-3 mb-2">
 <HelpCircle className="h-8 w-8 text-emerald-400"/>
 <h1 className="text-3xl font-bold text-white">Help Center</h1>
 </div>
 <p className="text-neutral-400 mt-1">Get help and find answers to common questions</p>
 </div>

 {/* Help Cards */}
 <div className="grid gap-4 md:grid-cols-2">
 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-emerald-500/10 rounded-lg flex items-center justify-center mb-4">
 <Book className="h-6 w-6 text-emerald-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Documentation</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Browse our comprehensive documentation and guides.
 </p>
 <span className="text-emerald-400 text-sm font-medium inline-flex items-center gap-1">
 Coming Soon
 </span>
 </div>

 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-6 hover:border-neutral-700 transition-colors">
 <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4">
 <MessageCircle className="h-6 w-6 text-blue-400"/>
 </div>
 <h3 className="text-lg font-semibold text-white mb-2">Support</h3>
 <p className="text-neutral-400 text-sm mb-4">
 Contact our support team for assistance.
 </p>
 <span className="text-blue-400 text-sm font-medium inline-flex items-center gap-1">
 Coming Soon
 </span>
 </div>
 </div>

 {/* FAQ Section Placeholder */}
 <div className="mt-8 border border-neutral-800 rounded-lg bg-neutral-900/50 p-8 text-center">
 <h2 className="text-xl font-semibold text-white mb-2">Frequently Asked Questions</h2>
 <p className="text-neutral-400">
 FAQ section coming soon. Contact your administrator for immediate assistance.
 </p>
 </div>
 </div>
 </div>
 );
}
